export const Loader = () => {
  return <img src={"/miscellaneous/loader.gif"} alt="Loading..." style={{ width: 690 }} />;
};
